import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getDessertFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How much does dessert food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Dessert food ${vehicleType} catering in ${cityName} typically depends on guest count, dessert type, service duration, and menu customization. Smaller events often start around a few hundred dollars, while weddings, corporate events, and large festivals may range higher. ${siteTitle} lets you compare real quotes from dessert food ${vehicleType}s so you can find the best option for your budget with no hidden fees.`
  },
  {
    question: `What types of desserts do dessert food ${vehicleType}s offer?`,
    answer: `Dessert food ${vehicleType}s offer a wide variety of sweet treats, including gourmet ice cream, boba tea, churros, donuts, cupcakes, cookies, shaved ice, waffles, and specialty pastries. Many dessert ${vehicleType}s also feature seasonal flavors, custom menus, and interactive options like made-to-order desserts, making them a fun and memorable addition to any event.`
  },
  {
    question: `Are dessert food ${vehicleType}s good for weddings and late-night snacks?`,
    answer: `Yes — dessert food ${vehicleType}s are especially popular for weddings, rehearsal dinners, and late-night wedding snacks. Many couples book dessert ${vehicleType}s to serve ice cream, donuts, churros, or sweet treats after dinner or during the reception. Dessert food ${vehicleType}s create a unique guest experience while keeping service simple and stress-free.`
  },
  {
    question: `Can dessert food ${vehicleType}s accommodate dietary needs like vegan or gluten-free?`,
    answer: `Many dessert food ${vehicleType}s offer vegan, gluten-free, dairy-free, and nut-free options. When you submit a catering request on ${siteTitle}, you can note any dietary preferences or restrictions, and we'll match you with dessert vendors that can accommodate your guests' needs.`
  },
  {
    question: `How far in advance should I book a dessert food ${vehicleType} for my event?`,
    answer: `For best availability, we recommend booking a dessert food ${vehicleType} 3–6 weeks in advance, especially for weddings, summer events, and corporate functions. However, last-minute bookings are sometimes possible depending on availability. Submitting your request early gives you more dessert options and flexibility.`
  }
];

function DessertFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getDessertFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default DessertFaq;
